const VISIBILE_CLASS = 'guide-showElement'
export const RELATIVE_POSITION_CLASS = 'guide-relativePosition'

/**
 *
 *
 * @export  查询父级的滚动的dom
 * @param {*} element
 * @return {*}
 */
export function getScrollParent(element) {
  let style = window.getComputedStyle(element)
  const excludeStaticParent = style.position === 'absolute'
  const overflowRegex = /(auto|scroll)/

  if (style.position === 'fixed') return document.body

  for (let parent = element; (parent = parent.parentElement);) {
    style = window.getComputedStyle(parent)
    if (excludeStaticParent && style.position === 'static') {
      continue
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) { return parent }
  }

  return document.body
}

/**
 *
 *
 * @export 判断是否为dom
 * @param {*} item
 * @return {*}
 */
export function isDOM(item) {
  return (typeof HTMLElement === 'function') ? (item instanceof HTMLElement) : (item && (typeof item === 'object') && (item.nodeType === 1) && (typeof item.nodeName === 'string'))
}

/**
 *
 * @export 滚动到指定的dom位置
 * @param {*} element
 */
export function scrollParentToElement(element) {
  const parent = getScrollParent(element)
  parent.scrollTop = element.offsetTop - parent.offsetTop
}

/**
 *
 *
 * @export 判断dom是否在视口内
 * @param {*} el
 * @return {*}
 */
export function isElementInViewport (el) {
  var rect = el.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  )
}

/**
 *
 *
 * @export 设置样式
 * @param {*} element
 * @param {*} style
 */
export function setStyle(element, style) {
  let cssText = ''

  if (element.style.cssText) {
    cssText += element.style.cssText
  }

  if (typeof style === 'string') {
    cssText += style
  } else {
    for (const rule in style) {
      cssText += `${rule}:${style[rule]};`
    }
  }

  element.style.cssText = cssText
}

/**
 *
 *
 * @export 获取样式的值
 * @param {*} element
 * @param {*} propName
 * @return {*}
 */
export function getPropValue(element, propName) {
  let propValue = ''
  if (element.currentStyle) {
    // IE
    propValue = element.currentStyle[propName]
  } else if (document.defaultView && document.defaultView.getComputedStyle) {
    // Others
    propValue = document.defaultView
      .getComputedStyle(element, null)
      .getPropertyValue(propName)
  }

  // Prevent exception in IE
  if (propValue && propValue.toLowerCase) {
    return propValue.toLowerCase()
  } else {
    return propValue
  }
}

/**
 *
 *
 * @export 移除添加到z-index和定位，dom会被遮罩层盖住
 * @param {*} element
 */
export function setElementHidden(element) {
  if (!isDOM(element)) {
    if (typeof element === 'string') {
      element = document.querySelector(element)
    } else if (typeof element === 'object' && element.$el) {
      element = element.$el
    } else {
      throw Error('请传入正确的元素')
    }
  }
  removeClass(element, VISIBILE_CLASS)
  removeClass(element, RELATIVE_POSITION_CLASS)
}

/**
 *
 *
 * @export 添加z-index和定位（如果没有定位则添加相对定位）
 * @param {*} element
 */
export function setShowElement(element) {
  addClass(element, VISIBILE_CLASS)
  setElementPosition(element)
}

export function setElementPosition(element) {
  const currentElementPosition = getPropValue(element, 'position')
  if (
    currentElementPosition !== 'absolute' &&
    currentElementPosition !== 'relative' &&
    currentElementPosition !== 'sticky' &&
    currentElementPosition !== 'fixed'
  ) {
    // change to new intro item
    addClass(element, RELATIVE_POSITION_CLASS)
  }
}

function forEach(arr, forEachFnc, completeFnc) {
  if (arr) {
    for (let i = 0, len = arr.length; i < len; i++) {
      forEachFnc(arr[i], i)
    }
  }

  if (typeof completeFnc === 'function') {
    completeFnc()
  }
}

export function addClass(element, className) {
  if (element instanceof SVGElement) {
    // svg
    const pre = element.getAttribute('class') || ''

    if (!pre.match(className)) {
      // check if element doesn't already have className
      element.setAttribute('class', `${pre} ${className}`)
    }
  } else {
    if (element.classList !== undefined) {
      // check for modern classList property
      const classes = className.split(' ')
      forEach(classes, (cls) => {
        element.classList.add(cls)
      })
    } else if (!element.className.match(className)) {
      // check if element doesn't already have className
      element.className += ` ${className}`
    }
  }
}

export function removeClass(element, classNameRegex) {
  if (element instanceof SVGElement) {
    const pre = element.getAttribute('class') || ''

    element.setAttribute(
      'class',
      pre.replace(classNameRegex, '').replace(/^\s+|\s+$/g, '')
    )
  } else {
    element.className = element.className
      .replace(classNameRegex, '')
      .replace(/^\s+|\s+$/g, '')
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-guide/utils.js